import React from 'react';

import { Photo } from 'components';

import cx from 'classnames';
import styles from './styles.scss';

export default class FavoritePickerPhoto extends React.PureComponent {
  onMouseDown = e => {
    const { photo } = this.props;

    this.props.setDragging(photo);
  };

  render() {
    const { className, photo, childBirthday, isMonthSpread } = this.props;
    const { ratio } = photo.get('exif', {});
    const classes = cx(className || '', styles.photo);

    const sizer = {
      paddingBottom: ratio * 100 + '%',
    };

    return (
      <div className={classes} onMouseDown={this.onMouseDown}>
        <div className={styles.inner} style={sizer}>
          <Photo
            className={styles.image}
            photo={photo}
            backgroundImage={true}
            childBirthday={childBirthday}
            dateFormat={isMonthSpread ? 'MMMM YYYY' : null}
            showUseCount
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/favorite-picker-photo/index.js